require('../../shared/highcharts-config')

const Perf_chart = require('../performances/perf-chart'),
  data = {
    name: ['P1', 'P2', 'P3', 'P4', 'P5', 'P6', 'P7', 'P8', 'P9', 'P10'],
    perf: [2.27, 2.52, 3.54, 3.46, 4.43, 6.59, 7.24, 7.89, 8.57, 10.17],
    vol:  [1.20, 1.60, 2.06, 2.29, 2.80, 3.64, 4.14, 4.64, 5.04,  5.83]
  }

$(function() {
  Perf_chart(data)
})
